<template>
  <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between">
    <ul class="tw-flex tw-w-full tw-flex-wrap tw-gap-4 md:tw-w-auto">
      <slot />
    </ul>
    <div
      class="tw-mt-4 tw-flex tw-w-full tw-flex-wrap tw-justify-end tw-gap-4 md:tw-mt-0 md:tw-w-auto"
    >
      <slot name="tabbarActions" />
    </div>
  </div>
</template>
